<script>
	import { Col, Container, Row } from '@sveltestrap/sveltestrap';
</script>

<footer class="footer">
	<Container fluid>
		<Row>
			<Col sm={6}>
				{new Date().getFullYear()} © D-Cine.net.
			</Col>
			<Col sm={6}>
				<div class="text-sm-end d-none d-sm-block">Developed by James Gardiner</div>
			</Col>
		</Row>
	</Container>
</footer>
